import { Component, Host, h, Prop, State, Event, EventEmitter } from '@stencil/core';

@Component({
  tag: 'lilu-img',
  styleUrl: 'lilu-img.scss',
  shadow: true,
})
export class LiluImg {
  @Prop() src: string = ''; // backend sends it as DESKTOP image
  @Prop() srcset: string = ''; // backend sends it as MOBILE image

  @Prop() alt = '';
  @Prop() url = '';

  @Prop() mobilesrcset: string = ''; // legacy, not used in production
  @Prop() appearance = ''; // used on add to-to-cart

  @Event() imgLoaded: EventEmitter<object>;

  // https://www.svgrepo.com/
  readonly placeholder: string =
    'data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4KPHN2ZyB3aWR0aD0iODAwcHgiIGhlaWdodD0iODAwcHgiIHZpZXdCb3g9IjAgMCA0MCA0MCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICA8cGF0aCBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0gMTYgMTEuMTUgQyAxMy44NzQgMTEuMTUgMTIuMTUgMTIuODc0IDEyLjE1IDE1IEMgMTIuMTUgMTcuMTI2IDEzLjg3NCAxOC44NSAxNiAxOC44NSBDIDE4LjEyNiAxOC44NSAxOS44NSAxNy4xMjYgMTkuODUgMTUgQyAxOS44NSAxMi44NzQgMTguMTI2IDExLjE1IDE2IDExLjE1IFogTSAxMy44NSAxNSBDIDEzLjg1IDEzLjgxMyAxNC44MTMgMTIuODUgMTYgMTIuODUgQyAxNy4xODcgMTIuODUgMTguMTUgMTMuODEzIDE4LjE1IDE1IEMgMTguMTUgMTYuMTg3IDE3LjE4NyAxNy4xNSAxNiAxNy4xNSBDIDE0LjgxMyAxNy4xNSAxMy44NSAxNi4xODcgMTMuODUgMTUgWiIgZmlsbD0iIzRmNTU1YiIgZmlsbC1ydWxlPSJldmVub2RkIi8+CiAgPHBhdGggY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNIDEwIDcgTCAzMCA3IEMgMzEuNjU3IDcgMzMgOC4zNDMgMzMgMTAgTCAzMyAzMCBDIDMzIDMxLjY1NyAzMS42NTcgMzMgMzAgMzMgTCAxMCAzMyBDIDguMzQzIDMzIDcgMzEuNjU3IDcgMzAgTCA3IDEwIEMgNyA4LjM0MyA4LjM0MyA3IDEwIDcgWiBNIDkgMzAgTCA5IDI5LjU5MSBMIDI1LjAzNiAxOS40IEMgMjUuNDA5IDE5LjE2MiAyNS44OTMgMTkuMTk4IDI2LjIyNyAxOS40ODggTCAzMSAyMy42MjQgTCAzMSAzMCBDIDMxIDMwLjU1MiAzMC41NTIgMzEgMzAgMzEgTCAxMCAzMSBDIDkuNDQ4IDMxIDkgMzAuNTUyIDkgMzAgWiBNIDI2Ljg2NCAxNy40IEwgMzEgMjAuOTg0IEwgMzEgMTAgQyAzMSA5LjQ0OCAzMC41NTIgOSAzMCA5IEwgMTAgOSBDIDkuNDQ4IDkgOSA5LjQ0OCA5IDEwIEwgOSAyNy4yMjIgTCAyNC41NTUgMTcuMzM2IEMgMjUuMjYgMTYuODY2IDI2LjE4NiAxNi44OTEgMjYuODY0IDE3LjQgWiIgZmlsbD0iIzRmNTU1YiIgZmlsbC1ydWxlPSJldmVub2RkIi8+Cjwvc3ZnPg==';

  @State() needsPictureTag: boolean = false;

  // backend will pass a desktop and an mobile image. They will have different aspect ratio, so, <picture> will be always rendered.
  componentWillLoad() {
    if (this.srcset && this.srcset.length > 0 && this.srcset !== this.src) {
      // there is a mobile image different than desktop
      this.needsPictureTag = true;
    }
  }

  onImgNotLoadedHandler(_) {
    this.src = this.placeholder;
    this.srcset = '';
  }

  onImgLoadedHandler() {
    this.imgLoaded.emit({ imgUrl: this.src });
  }

  getImgTag() {
    return (
      <img
        src={`${this.src}`}
        alt={`${this.alt}`}
        loading="lazy"
        decoding="async"
        draggable={false}
        onError={this.onImgNotLoadedHandler.bind(this)}
        onLoad={this.onImgLoadedHandler.bind(this)}
      />
    );
  }

  renderPicture() {
    return (
      <div class={`img_container ${this.appearance}`}>
        {this.needsPictureTag ? (
          <picture>
            <source media="(min-width: 768px)" srcSet={`${this.src}`} />
            <source media="(max-width: 767px)" srcSet={`${this.srcset}`} />
            {this.getImgTag()}
          </picture>
        ) : (
          this.getImgTag()
        )}
      </div>
    );
  }

  render() {
    return <Host>{this.url !== '' ? <a href={`${this.url}`}>{this.renderPicture()}</a> : this.renderPicture()}</Host>;
  }
}
